import { Link } from "react-router-dom";

// The /join booking button replicated site-wide: gold pill wrapped in double
// expanding pulse rings, with the repeating glow-surge animation.
export default function AnimatedBookButton({ to, href, onClick, testid, className = "", children }) {
  const cls = `sl-book-btn btn-gold inline-flex items-center justify-center gap-2.5 font-bold px-8 py-4 rounded-full text-base sm:text-lg ${className}`;
  return (
    <span className={`sl-book-wrap ${className.includes("w-full") ? "w-full" : ""}`}>
      {to ? (
        <Link to={to} data-testid={testid} className={cls}>
          {children}
        </Link>
      ) : href ? (
        <a href={href} data-testid={testid} className={cls}>
          {children}
        </a>
      ) : (
        <button type="button" onClick={onClick} data-testid={testid} className={cls}>
          {children}
        </button>
      )}
    </span>
  );
}